<template>
  <v-main id="documentation">
    <documentation-toc content-selector="#documentation"></documentation-toc>
    <h1 class="display-2 font-weight-light text-uppercase pb-4">Passport Photo Guidelines</h1>
    <h2 class="display-1 bold text-uppercase pb-4">Dimensions and size of your image</h2>
    <v-row>
      <v-col cols="12" class="col-md-6">
        <v-alert
            color="blue-grey darken-1"
            dark
            border="left"
            prominent
        >
          <template v-slot:prepend>
            <v-avatar color="blue-grey lighten-1" class="mr-2" size="48">
              <span class="white--text headline">1</span>
            </v-avatar>
          </template>
          The photographs should not be more than 6 months old and shall be <strong>45mm in height x 38 mm in
          width</strong> or <strong>(1
          ¾” x 1 ½”)</strong>
        </v-alert>
        <v-alert
            color="blue-grey darken-1"
            dark
            border="left"
            prominent
        >
          <template v-slot:prepend>
            <v-avatar color="blue-grey lighten-1" class="mr-2" size="48">
              <span class="white--text headline">2</span>
            </v-avatar>
          </template>
          The image shall be <strong>3 to 5mm from the top edge to the head, the chin 10 to 15mm from the bottom
          edge</strong> and
          show a close-up of the applicant’s head and the top of the shoulders. The face shall look directly at the
          camera with both ears showing and shall take up 70-80 percent of the vertical dimension of the picture.
        </v-alert>
        <v-alert
            color="blue-grey darken-1"
            dark
            border="left"
            prominent
        >
          <template v-slot:prepend>
            <v-avatar color="blue-grey lighten-1" class="mr-2" size="48">
              <span class="white--text headline">3</span>
            </v-avatar>
          </template>
          Resolution of digital version of the photo shall be 300dpi
        </v-alert>
      </v-col>
      <v-col cols="12" class="col-md-6">
        <v-img src="/img/photo-dimensions@2x.png" alt="Photo dimensions" max-width="380px"></v-img>
      </v-col>
    </v-row>
    <h2 class="display-1 bold text-uppercase pb-4">Photo image requirements</h2>
    <v-row v-for="example in examples" v-bind:key="example.index">
      <v-col cols="12" class="col-md-6">
        <v-row>
          <h3 class="col-1 flex-grow-0 flex-shrink-0 display-1 text-center">{{ example.index }}</h3>
          <div class="col-11 flex-grow-1 flex-shrink-0" v-html="example.description"></div>
        </v-row>
      </v-col>
      <v-col cols="12" class="col-md-6">
        <v-img :src="`/img/example-${example.index.toLowerCase()}@2x.png`" max-width="440px"></v-img>
      </v-col>
    </v-row>
    <v-alert
        text
        prominent
        type="error"
        icon="mdi-exclamation-thick"
    >
      The requirement to show ears can be waived on cases by case for applicants whose family members firmly refuse to
      show ears or take off hijabs based on religious grounds (applicable for passport pictures only).
      <v-divider
          class="my-4 error"
          style="opacity: 0.22"
      />
      Please advice Experts to make serious effort to convince the applicants to make photos that are showing their
      ears, such exceptions for religious grounds can not be made very often.
      <v-divider
          class="my-4 error"
          style="opacity: 0.22"
      />
      Applicant should be advised that this will also delay passport processing time from 10 to 14 days.
    </v-alert>
  </v-main>
</template>
<script>
    import DocumentationToc from '../components/App/DocumentationToc'

    export default {
        components: {
            DocumentationToc
        },
        filters: {
            indexToLetter(i) {
                const abcStart = 65
                return String.fromCharCode(i + abcStart)
            }
        },
        data() {
            return {
                examples: [
                    {
                        "index": "A",
                        "description": "The applicant should have a neutral expression and closed mouth"
                    },
                    {
                        "index": "B",
                        "description": "Ears must be clearly visible; all hair must be put behind of ears. If Muslim woman chooses to do photo wearing hijab, ears must still be visible"
                    },
                    {
                        "index": "C",
                        "description": "Shirts and blouses must cover chest area as much as possible; No sleeveless or tank tops. Chest area must be covered and visual"
                    },
                    {
                        "index": "D",
                        "description": "Eyes must look directly into camera; All applicants eyes should be open. There should be no hair obscuring the eyes or the forehead"
                    },
                    {
                        "index": "E",
                        "description": "Head and body must be straight; not twisted to the side"
                    },
                    {
                        "index": "F",
                        "description": "Photo should show the greater part of the torso"
                    },
                    {
                        "index": "G",
                        "description": "Photographs should not be overexposed or underexposed. No shadows"
                    },
                    {
                        "index": "H",
                        "description": "Background colors should be white or light grey, no texture or object in background"
                    },
                    {
                        "index": "I",
                        "description": "There must be contrast between image and background, e.g. no white shirt on white background etc..."
                    },
                    {
                        "index": "K",
                        "description": "No bold prints, or military shirts, or camouflage"
                    },
                    {
                        "index": "L",
                        "description": "No glasses,  shades or sunglasses"
                    },
                    {
                        "index": "M",
                        "description": "No head coverings. <strong>Except in the case of Muslim woman wearing hijab, but ears must still be visible, even if with hijab on.</strong>"
                    }
                ]
            }
        },
    }
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
</style>